export default __webpack_public_path__ + "static/lote_3-0c925a9de2a17b18beb6aee550dcf05d.png";